import { render, staticRenderFns } from "./vipOrderModal.vue?vue&type=template&id=3ae99c22&scoped=true"
import script from "./vipOrderModal.vue?vue&type=script&lang=js"
export * from "./vipOrderModal.vue?vue&type=script&lang=js"
import style0 from "./vipOrderModal.vue?vue&type=style&index=0&id=3ae99c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae99c22",
  null
  
)

export default component.exports